module.exports = __webpack_public_path__ + "img/4-2.94eafa76.svg";